import React, { useState, useEffect } from "react";
import { Col, Layout, Typography, Row, Modal, Input, message } from "antd";
import { connect, useSelector } from "react-redux";
import { getAllOffers, giveOffer } from "../Redux/Consultant/reducer";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import Header from "../Authorized/Header";
import constants from "../Redux/constants";
import { StyledButton, StyledLink } from "../styled-components/components";
import moment from "moment";
import { Helmet } from "react-helmet";
import ConsultantProfileCompletion from "./Profile/ConsultantProfileCompletion";

const Offers = (props) => {
  const [loading, setLoading] = useState(true);
  const { getAllOffers, giveOffer } = props;
  const { allOffers } = useSelector((state) => state.consultantStore);
  useEffect(() => {
    const fetchAllOffers = async () => {
      const { responseStatus } = await getAllOffers();
      if (responseStatus === constants.status.success) {
        setLoading(false);
      }
    };
    fetchAllOffers();
  }, [getAllOffers]);
  const acceptOffer = async (reason, offerStatus, offerId) => {
    const data = { reason, offerStatus };
    const { responseStatus } = await giveOffer(offerId, data);
    if (responseStatus === constants.status.success) {
      message.success("Offer has been Accepted");
    }
  };
  const rejectOffer = async (reason, offerStatus, offerId) => {
    const data = { reason, offerStatus };
    const { responseStatus } = await giveOffer(offerId, data);
    if (responseStatus === constants.status.created) {
      message.success("Offer has been rejected");
    }
    if (responseStatus === constants.status.conflict) {
      message.success("Offer has already been Rejected");
    }
  };
  return (
    <Layout>
      <Helmet title="All Offers | Unicon" />
      <Header></Header>
      <Layout.Content>
        <ConsultantProfileCompletion />
        <Col>
          {loading ? (
            <Feedback icon={<LoadingOutlined />} title="Fetching All Offers" />
          ) : (
            <Col>
              {allOffers.length >= 1 ? (
                <OfferList
                  offers={allOffers}
                  acceptOffer={acceptOffer}
                  rejectOffer={rejectOffer}
                />
              ) : (
                <Col
                  md={{ span: 11 }}
                  style={{
                    padding: "1vh",
                    background: "#ffffff",
                    border: "1px solid #f4f4f4",
                    margin: "2vh",
                    marginLeft: "auto",
                    marginRight: "auto",
                    borderRadius: "2vh",
                  }}
                >
                  <Feedback status="404" title="No Offers Found!"></Feedback>
                </Col>
              )}
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const OfferList = ({ offers, acceptOffer, rejectOffer }) => {
  const cardStyle = {
    padding: "2vh",
    background: "#ffffff",
    border: "1px solid #f4f4f4",
    margin: "auto",
    marginBottom: "2vh",
    marginTop: "2vh",
    borderRadius: "4px",
  };
  return (
    <Col xl={{ span: 10 }} style={{ margin: "auto" }}>
      {offers.map((offer) => {
        return (
          <Col style={cardStyle}>
            <Offer
              offer={offer}
              acceptOffer={acceptOffer}
              rejectOffer={rejectOffer}
            />
          </Col>
        );
      })}
    </Col>
  );
};

const Offer = ({ offer, acceptOffer, rejectOffer }) => {
  const expiryDate = (date) => moment.utc(date).from(moment());
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  useEffect(() => {
    if (reason) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [reason]);
  const offerIsRejected = () => {
    rejectOffer(reason, "reject", offer.offerId);
    setOpen(false);
  };
  const offerIsAccepted = () => {
    setReason("");
    acceptOffer(reason, "accepted", offer.offerId);
  };
  return (
    <Col>
      <Row>
        <Col>
          <Row>
            <Typography.Text strong>Title:</Typography.Text>
            <Typography.Paragraph style={{ marginLeft: "2vh" }}>
              {offer.title}
            </Typography.Paragraph>
          </Row>
          <Row>
            <Typography.Text strong>Your Comment:</Typography.Text>
            <Typography.Paragraph style={{ marginLeft: "2vh" }}>
              {offer.comment}
            </Typography.Paragraph>
          </Row>
          <Row>
            <Typography.Text strong>Expires:</Typography.Text>
            <Typography.Paragraph style={{ marginLeft: "2vh" }}>
              {expiryDate(offer.offerExpiryDate)}
            </Typography.Paragraph>
          </Row>
        </Col>
      </Row>
      {offer.offerExpireStatus ? (
        <Col>
          {offer.offerStatus === constants.offerStatus.accepted ? (
            <Col>
              <StyledLink>Update Progress</StyledLink>
            </Col>
          ) : (
            <Col>
              {offer.offerStatus === constants.offerStatus.reject ? (
                <Col>
                  <Typography.Text>You have rejected the offer</Typography.Text>
                </Col>
              ) : null}
            </Col>
          )}
          {offer.offerStatus === constants.offerStatus.expired ? (
            <Col>
              <Typography.Text>This Offer has expired</Typography.Text>
            </Col>
          ) : null}
        </Col>
      ) : (
        <Col>
          <Col>
            {offer.offerStatus === constants.offerStatus.accepted ? (
              <Col>
                <StyledLink>Update Progress</StyledLink>
              </Col>
            ) : (
              <Col>
                {offer.offerStatus === constants.offerStatus.reject ? (
                  <Col>
                    <Typography.Text>
                      You have rejected the offer
                    </Typography.Text>
                  </Col>
                ) : (
                  <Row justify="space-between">
                    <Col>
                      <StyledButton
                        color="#d92626"
                        data-testid="submit-rejectOffer"
                        onClick={() => setOpen(true)}
                      >
                        Reject
                      </StyledButton>
                    </Col>
                    <Col>
                      <StyledButton
                        data-testid="submit-acceptOffer"
                        onClick={offerIsAccepted}
                      >
                        Accept
                      </StyledButton>
                    </Col>
                  </Row>
                )}
              </Col>
            )}
          </Col>
        </Col>
      )}
      <Modal
        visible={open}
        footer={null}
        width={416}
        onCancel={() => setOpen(false)}
      >
        <Col>
          <Row style={{ padding: "2vh" }}>
            <Typography.Text>Reason for denying the offer?</Typography.Text>
          </Row>
          <Row style={{ padding: "2vh" }}>
            <Input.TextArea
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter Reason"
              data-testid="rejectReason"
            />
          </Row>
          <Row justify="end" style={{ padding: "1vh" }}>
            <StyledButton
              disabled={isDisabled}
              onClick={offerIsRejected}
              data-testid="submit-reject"
            >
              Reject
            </StyledButton>
          </Row>
        </Col>
      </Modal>
    </Col>
  );
};

const mapDispatchToReducer = (dispatch) => {
  return {
    getAllOffers: () => dispatch(getAllOffers()),
    giveOffer: (offerId, data) => dispatch(giveOffer(offerId, data)),
  };
};

export default connect(null, mapDispatchToReducer)(Offers);

//add a message when user accepts an offer
